import { AuthService } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

export interface CheckMandatoryCountingRequest {
  warehouseId: string;
  itemNo: string;
  binCode: string;
}

export interface CheckMandatoryCountingResponse {
  requiresCounting: boolean;
  lastCountedDate?: string | null;
  daysSinceLastCounted?: number | null;
  currentQuantity: number;
  itemDescription: string;
  message: string;
  // Resttelling (compass.MandatoryCountingPickFirst): true = plukk først, tell rest etterpå.
  pickFirstMode?: boolean;
}

export interface SubmitMandatoryCountingRequest {
  warehouseID: string;
  itemNo: string;
  binCode: string;
  countedQuantity: number;
  pListID: number;
  pListLineNo: number;
}

export interface SubmitMandatoryCountingResponse {
  success: boolean;
  message: string;
  batchID: string;
  lineID: number;
  previousQuantity: number;
  newQuantity: number;
  deviation: number;
  exportedToERP: boolean;
  exportFilePath: string;
}

class MandatoryCountingService {
  /**
   * Check if mandatory counting is required for item/bin combination
   */
  async checkMandatoryCounting(
    companyNo: string,
    request: CheckMandatoryCountingRequest
  ): Promise<CheckMandatoryCountingResponse> {
    const url = `${API_BASE_URL}/${companyNo}/MandatoryCounting/check?warehouseId=${encodeURIComponent(request.warehouseId)}&itemNo=${encodeURIComponent(request.itemNo)}&binCode=${encodeURIComponent(request.binCode)}`;

    const response = await AuthService.authenticatedGet(url);

    if (!response.ok) {
      throw new Error(`Failed to check mandatory counting: ${response.statusText}`);
    }

    return await response.json();
  }

  /**
   * Submit mandatory counting during picking
   */
  async submitMandatoryCounting(
    companyNo: string,
    request: SubmitMandatoryCountingRequest
  ): Promise<SubmitMandatoryCountingResponse> {
    const url = `${API_BASE_URL}/${companyNo}/MandatoryCounting/submit`;

    const response = await AuthService.authenticatedPost(url, request);

    if (!response.ok) {
      throw new Error(`Failed to submit mandatory counting: ${response.statusText}`);
    }

    return await response.json();
  }
}

export const mandatoryCountingService = new MandatoryCountingService();
